<template>
  <div class="container">
    <content-template >
      <template slot="left">{{activity.name}}</template>
      <template slot="right">
        <li>
          <router-link :to="{path:'activity-rules',query: {id:activity.id}}">簡介及比賽規章</router-link>
        </li>
        <li>
          <router-link :to="{path:'online-enroll',query:{id:activity.id}}">線上報名</router-link>
        </li>
        <li>
          <a class="is-check" style="color: #5571EC;">比賽作品</a>
        </li>
      </template>
      <template slot="banner">
        <div class="col-xs-12 activity-bg none-padding" style="text-align: center;">
          <img :src="activity.banner_url" style="padding:0px; max-width: 100%;" alt="">
        </div>
      </template>
      <template slot="content" v-if="count > 0">
        <span class="news-title">比賽作品</span>
        <div class="transverse-line"></div>
        <div class="col-xs-12 none-padding" style="margin-top: 20px">
          <template v-for="(work,index) in works">
            <router-link :to="{path: 'activity-work', query: {id:work.id}}">
              <div class="col-xs-6 col-sm-4 one-works">
                <!--************判断是作品的类别*************-->
                <div v-if="work.file.type_id == 1">
                  <template v-if="work.file.value">
                    <img :src="work.file.value" alt="">
                  </template>
                  <template v-else>
                    <img src="@/assets/thumbnail.png">
                  </template>
                </div>
                <div v-else-if="work.file.type_id == 2">
                    <img :src="'http://img.youtube.com/vi/' + work.youtube_id + '/default.jpg'" alt="">
                </div>
                <div v-else-if="work.file.type_id == 3">
                  <img src="@/assets/file-thumbnail.png">
                </div>
                <div v-else>
                  <div>這是文字</div>
                </div>
                <span class="works-title" style="-webkit-box-orient: vertical;">{{work.value[0].value}}</span>
                <div class="foot">
                  <div class="works-desc">
                    <span>No.{{ (index + 1) + 12 * (nowPage-1)}}</span>
                    <span class="works-yes"></span>
                    <span class="works-votes">{{work.vote_count}}票</span>
                  </div>
                  <label class="likes"></label>
                </div>
              </div>
            </router-link>
          </template>

          <!--<div class="col-xs-6 col-sm-4 one-works">-->
            <!--<img src="@/assets/image/works.png" alt="">-->
            <!--<span class="works-title">汇集精英，夺杯光荣</span>-->
            <!--<div class="foot">-->
              <!--<div class="works-desc">-->
                <!--<span>No.043</span>-->
                <!--<span class="works-yes"></span>-->
                <!--<span class="works-votes">21票</span>-->
              <!--</div>-->
              <!--<label class="likes"></label>-->
            <!--</div>-->
          <!--</div>-->

        </div>
        <template v-if="totalPages >= 1">
          <mo-paging
            :totalPages="totalPages"
            v-on:get-list="getList">
          </mo-paging>
        </template>
      </template>
      <template slot="content" v-else-if="isSuccess && totalPages < 1"><div class="enroll-success">暫時沒有作品，趕快來報名吧</div></template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'
import MoPaging from '../pages'

export default {
  components: {
    'content-template': contentTemplate,
    MoPaging
  },
  data () {
    return {
      activity: [],
      works: [],  // 作品列表
      pageSize: 12, //每页显示10条数据
      currentPage: 1, //当前页码
      count: 0, //总记录数
      totalPages: 0,	//总页数
      items: [1, 10, 10, 6],
      tiem: 0,
      nowPage: 1,
      isSuccess: false
    }
  },
  methods: {
    // 获取作品总数量
    getCount (id) {
      var that = this
      var url = 'activity/works/count/' + id
      this.$axios.get(url)
        .then(function (response) {
          that.isSuccess = true
          if (response.data.code === 1) {
            // 总数量
            that.count = response.data.data.counts
            // 总页数
            that.totalPages = Math.ceil(that.count / that.pageSize)
            // console.log('页数',that.totalPages)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 根据页码获取数据
    getList: function (page) {
      var that = this
      var id = this.$route.query.id
      var url = 'activity/works?id=' + id + '&page=' + page
      this.$axios.get(url)
        .then(function (response) {
          if (response.data.code === 1) {
            that.works = response.data.data
            that.nowPage = page

            // that.works.thumbnail = 'http://img.youtube.com/vi/' + that.works.youtube_id + '/default.jpg'
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 从page组件传递过来的当前page
    // pageChange(page) {
    //   this.currentPage = page
    //   this.getList(page)
    // }

    // 根据活动id获取活动
    getActivity: function (id) {
      var that = this
      this.$axios.get('/activity/' + id)
        .then(function (response) {
          that.activity = response.data.data
          // console.log(that.activity)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  mounted: function () {
    var id = this.$route.query.id
    // 请求页数
    this.getCount(id)
    this.getActivity(id)
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  .ac-time {
    text-align: right;
    font-size: 16px;
    color: #565656;
  }

  .one-works {
    position: relative;
    border: 1px solid #C0C2C5;
    width: 210px;
    height: 240px;
    padding: 0px;

    margin-left: 15px;
    margin-bottom: 15px;
  }

  .one-works img {
    width: 208px;
    height: 140px;
  }

  .one-works span {
    color: #565656;
    margin: 0 5px;
  }

  .one-works .works-title {
    position: absolute;
    top: 150px;
  }

  .one-works .foot {
    position: absolute;
    width: 100%;
    bottom: 0px;
  }

  .one-works .works-desc {
    display: inline-block;
    border: 1px solid #C0C2C5;
    border-radius: 110px;
    margin-top: 7px;
    margin-left: 5px;
  }

  .one-works .works-yes {
    display: inline-block;
    width: 17px;
    height: 17px;
    margin-left: 15px;
    margin-right: 5px;
    background: url('yes.png') no-repeat;
    background-size: 17px 17px;
    background-position: 40%;
  }

  .one-works .likes {
    display: inline-block;
    float: right;
    margin-right: 10px;
    background: #C0C2C5 url('heart.png') no-repeat;
    background-size: 25px 20px;
    background-position: center;
    width: 35px;
    height: 35px;
    border-radius: 35px;
  }

  @media (max-width: 992px) {
    .one-works {
      width: 150px;
      height: 168px;
      margin-left: 10px;
      margin-bottom: 10px;
    }

    .one-works img {
      width: 148px;
      height: 95px;
    }

    .one-works .works-title {
      position: absolute;
      top: 95px;
      height: 42px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    .one-works .foot {
      height: 30px;
    }

    .one-works .works-desc {
      font-size: 12px;
      border-radius: 110px;
      margin-top: 5px;
      margin-left: 0px;
    }

    .one-works .works-yes {
      width: 10px;
      height: 10px;
      margin-left: 5px;
      margin-right: 0px;
      background-size: 10px 10px;
      background-position: 40%;
    }

    .one-works .likes {
      margin-right: 5px;
      background-size: 17px 14px;
      width: 24px;
      height: 24px;
      border-radius: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/works.vue